import { defineMessages } from 'react-intl';

export default defineMessages({
  description: {
    id: 'frontbucket.dashboard.overview.upgradeBanner.description',
    description: 'Descriptive text of upgrade banner',
    defaultMessage: `You're currently on a Free plan. Upgrade to manage your growing team with ease – get advanced admin permissions, security features, additional build minutes, and more.`,
  },
  header: {
    id: 'frontbucket.dashboard.overview.upgradeBanner.header',
    description: 'Header of upgrade banner',
    defaultMessage: 'Get more out of Bitbucket',
  },
  upgrade: {
    id: 'frontbucket.dashboard.overview.upgradeBanner.upgrade',
    description: 'A button for redirecting to plans page ',
    defaultMessage: 'Upgrade',
  },
});
